<template>
    <v-card class="roteirizacao-map-legend" elevation="3" :aria-label="$t('routePlanning.routingMap.legend.title')">
        <button
            type="button"
            class="roteirizacao-map-legend__header"
            :aria-expanded="String(open)"
            @click="open = !open"
        >
            <v-icon small class="mr-1">mdi-map-legend</v-icon>
            <span class="roteirizacao-map-legend__title">{{ $t('routePlanning.routingMap.legend.title') }}</span>
            <v-icon small class="ml-auto">{{ open ? 'mdi-chevron-down' : 'mdi-chevron-up' }}</v-icon>
        </button>
        <div v-show="open" class="roteirizacao-map-legend__body">
            <div v-if="showDepot" class="roteirizacao-map-legend__row">
                <span class="roteirizacao-map-legend__pin roteirizacao-map-legend__pin--depot">D</span>
                {{ $t('routePlanning.routingMap.legend.depot') }}
            </div>
            <div v-if="showBase" class="roteirizacao-map-legend__row">
                <span class="roteirizacao-map-legend__pin roteirizacao-map-legend__pin--base">G</span>
                {{ $t('routePlanning.routingMap.legend.base') }}
            </div>
            <div v-if="showInvalid" class="roteirizacao-map-legend__row">
                <span class="roteirizacao-map-legend__pin roteirizacao-map-legend__pin--invalid">!</span>
                {{ $t('routePlanning.routingMap.legend.invalidStop') }}
            </div>
            <div v-if="showCsv" class="roteirizacao-map-legend__row">
                <span class="roteirizacao-map-legend__dot roteirizacao-map-legend__dot--csv"></span>
                {{ $t('routePlanning.routingMap.legend.csvPoint') }}
            </div>
            <div v-if="showCsv" class="roteirizacao-map-legend__row">
                <span class="roteirizacao-map-legend__dot roteirizacao-map-legend__dot--csv-edited"></span>
                {{ $t('routePlanning.routingMap.legend.csvPointEdited') }}
            </div>
            <div v-if="showRiskZones" class="roteirizacao-map-legend__row">
                <span class="roteirizacao-map-legend__zone"></span>
                {{ $t('routePlanning.routingMap.legend.riskZone') }}
            </div>
            <div v-if="showWalk" class="roteirizacao-map-legend__row">
                <span class="roteirizacao-map-legend__line roteirizacao-map-legend__line--walk"></span>
                {{ $t('routePlanning.routingMap.legend.walkPath') }}
            </div>
            <template v-if="routes.length">
                <div class="roteirizacao-map-legend__section">{{ $t('routePlanning.routingMap.legend.routes') }}</div>
                <div class="roteirizacao-map-legend__routes">
                    <div v-for="r in routes" :key="r.id" class="roteirizacao-map-legend__row">
                        <span class="roteirizacao-map-legend__line" :style="{ background: r.color }"></span>
                        {{ r.label }}
                    </div>
                </div>
            </template>
        </div>
    </v-card>
</template>

<script>
export default {
    name: 'RoteirizacaoMapLegend',
    props: {
        /** [{ id, label, color }] das rotas visíveis no mapa. */
        routes: { type: Array, default: () => [] },
        showDepot: { type: Boolean, default: false },
        showBase: { type: Boolean, default: false },
        showInvalid: { type: Boolean, default: false },
        showCsv: { type: Boolean, default: false },
        showWalk: { type: Boolean, default: false },
        /** Zonas de Risco desenhadas no mapa (overlay ligado). */
        showRiskZones: { type: Boolean, default: false },
    },
    data: () => ({ open: true }),
};
</script>

<style scoped>
.roteirizacao-map-legend__zone {
    display: inline-block;
    width: 16px;
    height: 12px;
    margin-right: 6px;
    flex-shrink: 0;
    border: 2px dashed #d32f2f;
    background: repeating-linear-gradient(45deg, rgba(211, 47, 47, 0.45) 0 2px, rgba(211, 47, 47, 0.08) 2px 5px);
}
.roteirizacao-map-legend {
    font-size: 12px;
    line-height: 1.3;
    min-width: 150px;
    max-width: 220px;
    opacity: 0.96;
}
.roteirizacao-map-legend__header {
    display: flex;
    align-items: center;
    width: 100%;
    padding: 6px 8px;
    font-weight: 600;
    cursor: pointer;
    background: none;
    border: 0;
    color: inherit;
}
.roteirizacao-map-legend__body {
    padding: 0 8px 8px;
}
.roteirizacao-map-legend__row {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 2px 0;
}
.roteirizacao-map-legend__section {
    margin: 6px 0 2px;
    font-weight: 600;
    opacity: 0.8;
}
.roteirizacao-map-legend__routes {
    max-height: 140px;
    overflow-y: auto;
}
.roteirizacao-map-legend__pin {
    flex: 0 0 auto;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    border: 2px solid #fff;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.4);
    color: #fff;
    font-size: 9px;
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
}
.roteirizacao-map-legend__pin--depot { background: linear-gradient(160deg, #42a5f5, #0d47a1); }
.roteirizacao-map-legend__pin--base { background: linear-gradient(160deg, #66bb6a, #1b5e20); }
.roteirizacao-map-legend__pin--invalid { background: linear-gradient(160deg, #ef5350, #b71c1c); }
.roteirizacao-map-legend__dot {
    flex: 0 0 auto;
    width: 12px;
    height: 12px;
    margin: 0 4px;
    border-radius: 50%;
    box-sizing: border-box;
    border: 1px solid;
}
.roteirizacao-map-legend__dot--csv { background: #1976d2; border-color: #0d47a1; }
.roteirizacao-map-legend__dot--csv-edited { background: #ff9800; border-color: #e65100; }
.roteirizacao-map-legend__line {
    flex: 0 0 auto;
    width: 20px;
    height: 4px;
    border-radius: 2px;
}
.roteirizacao-map-legend__line--walk {
    height: 0;
    border-top: 4px dotted #757575;
    border-radius: 0;
}
</style>
